"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportItemValidationSchema = exports.REPORT_SUBMIT = exports.REPORT = void 0;
var _zod = require("zod");
const REPORT = exports.REPORT = 'report';
const REPORT_SUBMIT = exports.REPORT_SUBMIT = 'report-submit';
const reportItemValidationSchema = exports.reportItemValidationSchema = _zod.z.object({
  email: _zod.z.string().email(),
  reason: _zod.z.string().min(1)
});
